import { ColumnRulesWithMetaData } from '@/tableDefinitionEditor/columnRules/columnRuleBuilder.constants';
import { SUPPORT_LINK } from '@/utilities/externalLinks';
import type { ColumnRule } from '@/tableDefinitionEditor/columnRules/columnRule.constants';
import type {
  ColumnInputOptions,
  ColumnRuleWithMetadata,
  DropdownInputOptions,
  InputTypeOptions,
  NumberInputOptions,
  ParameterWithMetadata,
  TextInputOptions,
} from '@/tableDefinitionEditor/columnRules/columnRuleBuilder.types';

export function isDropdownInputOptions(input: InputTypeOptions | undefined): input is DropdownInputOptions {
  return input?.type === 'optionDropdown';
}

export function isTextInputOptions(input: InputTypeOptions | undefined): input is TextInputOptions {
  return input?.type === 'text';
}

export function isColumnInputOptions(input: InputTypeOptions | undefined): input is ColumnInputOptions {
  return input?.type === 'columnDropdown';
}

export function isNumberOptions(input: InputTypeOptions | undefined): input is NumberInputOptions {
  return input?.type === 'number';
}

export function getColumnRuleWithMetaData(rule: ColumnRule): ColumnRuleWithMetadata | undefined {
  return ColumnRulesWithMetaData.find((columnRule) => columnRule.rule === rule);
}

export function getParameterWithMetadataFromColumnRule(
  rule: ColumnRuleWithMetadata,
  parameter: string,
): ParameterWithMetadata | undefined {
  return rule.allParameters.find((param) => param.parameter === parameter);
}

export const openTooltipLink = () => window.open(`${SUPPORT_LINK}/applying-column-rules`);
